import styled from "styled-components";
import { CarouselProductWrapper } from "../../../../../common/carousels/carousel-product/views/mobile/styled.js";
export const CarouselListWrapperHorizontal = styled.div.withConfig({
    displayName: "styled__CarouselListWrapperHorizontal",
    componentId: "sc-fe45a264-0"
})`
	& > .carousel-title {
		margin-top: 20px;
	}

	${CarouselProductWrapper} {
		display: flex;
		margin: 0;
		padding-bottom: 8px;
		overflow-x: scroll;

		article {
			margin-right: 8px;
			a {
				flex-direction: column;
				width: 160px;

				div {
					figure {
						height: 100px;
						max-width: none;
						img {
							width: 160px;
							height: 140px;
						}
					}
				}
			}
		}
	}
`;

//# sourceMappingURL=styled.js.map